import { IonCol, IonContent, IonGrid, IonHeader, IonPage, IonRow } from "@ionic/react";
import { useEffect } from "react";
import { useDispatch} from "react-redux";

import { findTemplates } from "../../store/templateList/actions/findTemplates";
import { CreateTemplateButton } from "./components/CreateTemplateButton";
import { TemplateListContainer } from "./components/TemplateListContainer";
import { TemplateSearchBar } from "./components/TemplateSearchBar";
import { Toolbar } from "./components/Toolbar";

export const TemplateList: React.FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
      dispatch(findTemplates());
  }, [dispatch]);

  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <Toolbar />
      </IonHeader>
      <IonContent fullscreen>
        <CreateTemplateButton />
        <section className="ion-padding">
          <IonGrid>
            <IonRow>
              <IonCol>
                <TemplateSearchBar />
              </IonCol>
            </IonRow>
          </IonGrid>
          <TemplateListContainer />
        </section>
      </IonContent>
    </IonPage>
  );
};
